import TemplateView from '../../../../TemplateView'

export default class CustomRadioButton extends TemplateView {
    constructor({
        additionalClass = '',
        radioWrapperAdditionalClass = '',
        label = '',
        name = '',
        onChangeCallback = () => {},
    } = {}) {
        super()

        this.callbacks = {
            onChangeCallback,
        }

        this.params = {
            additionalClass,
            radioWrapperAdditionalClass,
            label,
            name,
        }

        this.state = {
            selected: false,
        }

        this.onStatePropertyChanged('selected', (selected) => {
            this.getEl().toggleClass('selected', selected)
            this.$radio.prop('checked', selected)
        })
    }

    templateHtml() {
        return '<label class="customRadioButton <%=additionalClass%>">' +
               '    <div class="radioWrapper <%=radioWrapperAdditionalClass%>">' +
               '        <input type="radio" name="<%=name%>"/>' +
               '        <span><%=label%></span>' +
               '    </div>' +
               '</label>'
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
            label: this.params.label,
            name: this.params.name,
            radioWrapperAdditionalClass: this.params.radioWrapperAdditionalClass,
        }
    }

    afterRender() {
        this.$radio = this.find('input[type=radio]')
        this.$radio.on('change', () => {
            this.callbacks.onChangeCallback()
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/CustomRadioButton.js